import { Button } from "devextreme-react/button";
import DataGrid, {
  Column,
  Editing,
  FilterRow,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Lookup,
  Pager,
  Paging,
  Scrolling,
  Selection,
  Sorting,
  Summary,
  TotalItem,
} from "devextreme-react/data-grid";
import { Popup } from "devextreme-react/popup";
import { Toast } from "devextreme-react/toast";
import DataSource from "devextreme/data/data_source";
import notify from "devextreme/ui/notify";
import { memo, useCallback, useEffect, useRef, useState } from "react";
import { applicationID, relationId } from "../../../api/ApplicationID";
import { useRequestsApi } from "../../../Context/RequestsApi";
import { httpRequest } from "../../../functions";
import { validatePermission } from "../../../functions/validatePermission";
import ConsultaBoletoForm from "../../ConsultaBoletoForm";
import UpfPasswordComponent from "../UpfPasswordComponent";
// import {Lookup, DropDownOptions} from "devextreme-react/lookup";
import { ScrollView } from "devextreme-react";
import { LoadPanel } from "devextreme-react/load-panel";
import ExportingExcel from "../../../CardComponents/ExportingExcel";
import UpfPopupConfirmContextMenu from "../../../CardComponents/UpfPopupConfirmContextMenu";
import UpfPopupCustomForm from "../../../CardComponents/UpfPopupCustomForm";
import UpfPopupMessage from "../../../CardComponents/UpfPopupMessage";
import { useIndexTabPanelMain } from "../../../Context/IndexTabPanelMain";
import { useTabPanelItems } from "../../../Context/TabPanelItems";
import { useWidgetsTeleCob } from "../../../Context/WidgetsTeleCob";
import { changeDataRowColor } from "../../../functions/changeDataRowColor";
import { convertDate } from "../../../functions/convertDate";
import HtmlFormPopup from "../../HtmlFormPopup";
import RecordForm from "../../RecordForm";
import HistoricoCustomFormPopup from "../../RecordForm/HistoricoCustomFormPopup";
import TarefaHistoricoFormPopup from "../../TarefaHistoricoFormPopup";
import UpfAudio from "../UpfAudio";
import UpfFileSelect from "../UpfFileSelect";
import UpfHtmlEditor from "../UpfHtmlEditor";
// import {useQuery} from '@tanstack/react-query'
// import { useGetWidgetArrayGlobalState } from "../../../Context/GetWidgetArrayGlobalState";
// import { useHistoricoCustomFormPopupGlobalState } from "../../../Context/HistoricoCustomFormPopupGlobalState";
import { calculateCustomSummary } from "../../../functions/calculateCustomSummary";

const UpfDataGridField = (props) => {
  const refDataGrid = useRef(null);
  // const { getWidgetArrayGlobalState, setGetWidgetArrayGlobalState } = useGetWidgetArrayGlobalState();
  const { requestsApi } = useRequestsApi();
  // const {historicoCustomFormPopupGlobalState, setHistoricoCustomFormPopupGlobalState,} = useHistoricoCustomFormPopupGlobalState();
  const { setIndexTabPanelMain } = useIndexTabPanelMain();
  const { tabPanelItems, setTabPanelItems } = useTabPanelItems();
  const { widgetsTeleCob, setWidgetsTeleCob } = useWidgetsTeleCob();
  const [dataSourceBoletoState, setDataSourceBoletoState] = useState();
  const [consultaBoletoFormPopupState, setConsultaBoletoFormPopupState] =
    useState(false);
  const [dataSourceAtualState, setDataSourceAtualState] = useState([]);
  const [upfPopupCustomFormStates, setUpfPopupCustomFormStates] = useState({
    visible: false,
    title: null,
    formName: null,
    tarefaId: null,
    entityName: null,
    idValue: null,
    caption: null,
    estrutura: null,
    dados: null,
  });

  const [popupErrorVisibleState, setPopupErrorVisibleState] = useState(false);
  const [popupErrorMessageState, setPopupErrorMessageState] = useState("");

  const hidePopupError = () => {
    setPopupErrorVisibleState(false);
  };

  const [htmlTemplate, setHtmlTemplate] = useState();
  const [htmlPopupVisible, setHtmlPopupVisible] = useState();
  const [htmlFormPopupDataSourceState, setHtmlFormPopupDataSourceState] =
    useState();
  const [htmlFormPopupIdState, setHtmlFormPopupIdState] = useState();
  const [htmlPopupEntityNameState, setHtmlPopupEntityNameState] = useState();

  const [
    historicoCustomFormPopupVisibleState,
    setHistoricoCustomFormPopupVisibleState,
  ] = useState();
  const [
    tarefaHistoricoFormPopupVisibleState,
    setTarefaHistoricoFormPopupVisibleState,
  ] = useState();

  const hideUpfPopupCustomForm = () => {
    setUpfPopupCustomFormStates({
      ...upfPopupCustomFormStates,
      visible: false,
    });
  };

  const [modeEditDataGrid, setModeEditDataGrid] = useState({
    edit: false,
  });
  const [TabPanelDetailEntityItemState, SetTabPanelDetailEntityItemState] =
    useState();

  const [popupStates, setPopupStates] = useState({
    visible: false,
    message: null,
  });

  const hidePopup = () => {
    setPopupStates({
      ...popupStates,
      visible: false,
    });
  };
  const [selectedItensCount, setSelectedItensCount] = useState();
  const [selectedItens, setSelectedItens] = useState();

  const [visibleConfirmContextMenuState, setVisibleConfirmContextMenuState] =
    useState(false);
  const [contextMenuItemState, setContextMenuItemState] = useState();

  const hidePopupConfirmContextMenu = () => {
    setVisibleConfirmContextMenuState(false);
  };
  const [
    arrayLookupDataSourceEntityFields,
    setArrayLookupDataSourceEntityFieldsState,
  ] = useState([]);

  const loadingPanelOptions = {
    loadPanelVisible: false,
    showIndicator: true,
    shading: false,
    showPane: true,
    closeOnOutsideClick: false,
  };
  const [loadingPanelState, setLoadingPanelState] =
    useState(loadingPanelOptions);

  //Funções
  const hideLoadPanel = useCallback(() => {
    setLoadingPanelState({
      ...loadingPanelState,
      loadPanelVisible: false,
    });
  }, [loadingPanelState]);
  const showLoadPanel = useCallback(() => {
    setLoadingPanelState({
      ...loadingPanelState,
      loadPanelVisible: true,
    });
  }, [loadingPanelState]);

  //---------TOAST----------//
  //Estados
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "info",
    message: "",
  });

  //Funções
  const onHiding = useCallback(() => {
    hideLoadPanel();
    // modeEditOff()
    setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  }, [toastConfig]);

  useEffect(() => {
    if (props?.dataSourceAtual?.length > 0) {
      convertDate(props?.dataSourceAtual, props.colunasArray);
      setDataSourceAtualState(props?.dataSourceAtual);
    }
  }, [props?.dataSourceAtual]);

  const [stateModeEdit, setStateModeEdit] = useState(false);
  const toastConfiguration = useCallback(
    (visible, type, message) => {
      setToastConfig({
        ...toastConfig,
        isVisible: visible,
        type: type,
        message: message,
      });
    },
    [toastConfig]
  );

  const recordInsertJsonDetail = (entityNameGrid, formData) => {
    delete formData.id;
    showLoadPanel();
    httpRequest(
      "POST",
      requestsApi.insertRecordFromJson,
      requestsApi.basicAuth,
      {
        entityName: entityNameGrid,
        json: formData,
        applicationId: applicationID,
        relationId: relationId,
      }
    )
      .then((sender) => {
        //const senderUpdateRecordFromJson = JSON.parse(sender)
        // props.modeEditOff()
        toastConfiguration(true, "success", "Registro inserido com sucesso!");
        hideLoadPanel();
      })
      .catch((error) => {
        console.log(error);
      });
    // .catch((error) => {
    //     hideLoadPanel()
    //     if (error?.data?.error) {
    //         setMessageError(error.data.error)
    //         setPopup({
    //             ...popup
    //             , isVisible: true
    //             , message: "Atenção!"
    //         })
    //     }
    //     else {
    //         setMessageError(error?.statusText)
    //         setPopup({
    //             ...popup
    //             , isVisible: true
    //             , message: "Atenção!"
    //         })
    //     }
    // })
  };

  const recordUpdateJsonDetail = (entityNameGrid, jsonRow) => {
    // if(props.idValue) {
    httpRequest(
      "POST",
      requestsApi.updateRecordFromJson,
      requestsApi.basicAuth,
      {
        entityName: entityNameGrid,
        json: jsonRow,
        applicationId: applicationID,
        relationId: relationId,
      }
    )
      .then((sender) => {
        const senderUpdateRecordFromJson = JSON.parse(sender);
        // props.modeEditOff()
        toastConfiguration(
          true,
          "success",
          senderUpdateRecordFromJson.mensagem
        );
      })
      .catch((error) => {
        console.log(error);
      });
    // .catch((error)=>{
    //     if(error.data.error) {
    //         hideLoadPanel()
    //         setMessageError(error.data.error)
    //         setPopup({
    //             ...popup
    //                 ,isVisible: true
    //                 ,message: "Atenção!"
    //         })
    //     }
    //     else {
    //         hideLoadPanel()
    //         setMessageError(error.statusText)
    //         setPopup({
    //             ...popup
    //                 ,isVisible: true
    //                 ,message: "Atenção!"
    //         })
    //     }
    // })
    // }
  };

  const recordDeleteJsonDetail = (entityNameGrid, jsonRowId) => {
    httpRequest(
      "POST",
      requestsApi.deleteRecordFromJson,
      requestsApi.basicAuth,
      {
        entityName: entityNameGrid,
        applicationId: applicationID,
        relationId: relationId,
        fieldName: "id",
        expressao: jsonRowId,
      }
    ).then((sender) => {
      const senderUpdateRecordFromJson = JSON.parse(sender);
      // modeEditOff()
      toastConfiguration(true, "success", senderUpdateRecordFromJson.mensagem);
    });
    // .catch((error)=>{
    //     if(error.data.error) {
    //         hideLoadPanel()
    //         setMessageError(error.data.error)
    //         setPopup({
    //             ...popup
    //                 ,isVisible: true
    //                 ,message: "Atenção!"
    //         })
    //     }
    //     else {
    //         hideLoadPanel()
    //         setMessageError(error.statusText)
    //         setPopup({
    //             ...popup
    //                 ,isVisible: true
    //                 ,message: "Atenção!"
    //         })
    //     }
    // })
  };

  const openLogCustomForm = (entityStructureDetalhe, dataEntityDetalhe) => {
    showLoadPanel();
    entityStructureDetalhe["fieldsDefs"] = props.colunasArray;
    if (entityStructureDetalhe && dataEntityDetalhe) {
      setUpfPopupCustomFormStates({
        visible: true,
        title: `Log - ${entityStructureDetalhe.caption}`,
        formName: "LogCustomForm",
        entityName: entityStructureDetalhe.entityName,
        caption: entityStructureDetalhe.caption,
        idValue: props.masterEntityId,
        estrutura: entityStructureDetalhe,
        dados: dataEntityDetalhe,
      });
    }
    hideLoadPanel();
  };

  const configRecordFormStructureDetail = (
    keyFieldName,
    entityNameDetailParam
  ) => {
    showLoadPanel();

    httpRequest("POST", requestsApi.getDataEntity, requestsApi.basicAuth, {
      applicationId: applicationID,
      entityName: "entity",
      fieldName: "entityname",
      expressao: entityNameDetailParam,
    })
      .then((senderGetDataEntity) => {
        const resultGetDataEntity = JSON.parse(senderGetDataEntity);
        props.setEntityDataEntityState(resultGetDataEntity);
        // props.setIdValueDetailEntity(resultGetDataEntity.masterEntity[0].records[0].id)

        httpRequest(
          "POST",
          requestsApi.getEntityStructure,
          requestsApi.basicAuth,
          {
            entityName: "entity",
            applicationId: applicationID,
          }
        )
          .then((sender) => {
            props.setEntityStructureRecordFormPopupState(JSON.parse(sender));

            if (JSON.parse(sender)?.[0]?.lookUpEntities?.length > 0) {
              if (props.objectLookUpEntityViewsTipoProcessamento) {
                const lookUpEntityViewsTipoProcessamento = JSON.parse(
                  sender
                )[0]?.lookUpEntities.find(
                  (e) => e.lookUpEntity === "viewstipoprocessamentolookup"
                );

                if (lookUpEntityViewsTipoProcessamento) {
                  JSON.parse(sender)[0]?.lookUpEntities.splice(
                    JSON.parse(sender)[0]?.lookUpEntities.indexOf(
                      lookUpEntityViewsTipoProcessamento
                    ),
                    1,
                    props.objectLookUpEntityViewsTipoProcessamento
                  );
                } else {
                  JSON.parse(sender)[0]?.lookUpEntities?.push(
                    props.objectLookUpEntityViewsTipoProcessamento
                  );
                }
              }

              httpRequest(
                "POST",
                requestsApi.getLookupTable,
                requestsApi.basicAuth,
                {
                  lookUpEntities: JSON.parse(sender)?.[0]?.lookUpEntities,
                }
              )
                .then((sender) => {
                  props.setDataLookupRecordFormPopupState(JSON.parse(sender));

                  props.setPopupRecordFormOpen(true);
                  props.setPopupState(true);
                  props.setStateModeEdit(true);
                  props.setDetailEntityName("entity");
                  props.setDetailCaptionName("Entity");
                  props.setKeyFieldNameState(keyFieldName);
                  props.setPopupRecordFormAdd(false);
                  props.setIDValueDetailEntity(
                    resultGetDataEntity.masterEntity[0].records[0].id
                  );
                  hideLoadPanel();
                })
                .catch((error) => {
                  hideLoadPanel();
                  console.log(error);
                });
            } else {
              props.setPopupRecordFormOpen(true);
              props.setPopupState(true);
              props.setStateModeEdit(true);
              props.setDetailEntityName("entity");
              props.setDetailCaptionName("Entity");
              props.setKeyFieldNameState(keyFieldName);
              props.setPopupRecordFormAdd(false);
              props.setIDValueDetailEntity(
                resultGetDataEntity.masterEntity[0].records[0].id
              );
              hideLoadPanel();
            }
          })
          .catch((error) => {
            hideLoadPanel();
            console.log(error);
          });
      })
      .catch((error) => {
        hideLoadPanel();
        if (error?.data?.error) {
          props.hideLoadPanel();
          props.setMessageError(error.data.error);
          props.setPopup({
            ...props.popup,
            isVisible: true,
            message: `Erro: ${error?.status} ` + `(${error?.statusText})`,
          });
        } else {
          props.hideLoadPanel();
          props.setMessageError(error?.statusText);
          props.setPopup({
            ...props.popup,
            isVisible: true,
            message: `Erro: ${error?.status} ` + `(${error?.statusText})`,
          });
        }
      });
  };

  //---------TOAST----------//
  // const getEntityFieldsFunction = async () => {
  //     if(props.masterEntityName?.length > 0){
  //         await httpRequest('POST', requestsApi.getEntityFields, requestsApi.basicAuth,
  //         {
  //             "applicationId": applicationID
  //             ,"entityName": props.masterEntityName
  //         }
  //         )
  //         .then((sender) => {
  //             const resultgetEntityFieldsJson = JSON.parse(sender)
  //             setArrayLookupDataSourceEntityFieldsState(resultgetEntityFieldsJson)
  //         })
  //         .catch((error) => {
  //             hideLoadPanel()
  //             console.log(error)
  //         })
  //     }
  // }

  // const arrayLookupDataSourceEntityFieldsQuery = useQuery({ queryFn: getEntityFieldsFunction })
  const juntarDataDetalhes = (dataEntitysArray) => {
    const resultDetalhes = [];
    if (dataEntitysArray?.length > 0) {
      for (let c = 1; c <= dataEntitysArray.length - 1; c++) {
        if (dataEntitysArray[c]?.detailEntity?.length > 0) {
          for (
            let i = 0;
            i <= dataEntitysArray[c].detailEntity.length - 1;
            i++
          ) {
            resultDetalhes.push(dataEntitysArray[c]?.detailEntity[i]);
          }
        }
      }
    }
    return resultDetalhes;
  };

  const refreshDetailEntity = async (
    entityName,
    keyFieldName,
    tentarNovamente
  ) => {
    showLoadPanel();
    const arrayLookupsCurrentDetailEntity = [];

    //separa so as lookups da entidade atual para fazer a request
    for (let c = 0; c <= props.colunasArray.length - 1; c++) {
      if (props.colunasArray?.[c]?.lookUpListSource) {
        //checar nos fields da entidade detalhe se existe algum com lookupListSource, se tiver chama getLookupTable
        if (
          props?.lookUpEntities?.find(
            (e) => e.lookUpEntity === props.colunasArray?.[c]?.lookUpListSource
          )
        ) {
          arrayLookupsCurrentDetailEntity.push(
            props.lookUpEntities.find(
              (e) =>
                e.lookUpEntity === props.colunasArray?.[c]?.lookUpListSource
            )
          );
        }
      }
    }

    if (arrayLookupsCurrentDetailEntity.length > 0) {
      await httpRequest(
        "POST",
        requestsApi.getLookupTable,
        requestsApi.basicAuth,
        {
          lookUpEntities: arrayLookupsCurrentDetailEntity,
        }
      )
        .then((sender) => {
          const senderDataLookup = JSON.parse(sender);
          const lookupsObj = { ...props.dataLookup, ...senderDataLookup };
          props.setDataLookup(lookupsObj);

          httpRequest(
            "POST",
            requestsApi.getDataEntity,
            requestsApi.basicAuth,
            {
              applicationId: applicationID,
              entityName: props.entityNameGrid,
              fieldName: props.estruturaDaEntidadeDetalhe.keyFieldName,
              expressao: props.masterEntityId,
            }
          )
            .then((senderGetDataEntity) => {
              const resultGetDataEntity = JSON.parse(senderGetDataEntity);

              convertDate(
                resultGetDataEntity.masterEntity[0]?.records,
                props.colunasArray
              );
              setDataSourceAtualState(
                resultGetDataEntity.masterEntity[0]?.records
              );

              hideLoadPanel();
            })
            .catch((error) => {
              // setDataSourceAtualState([])

              // console.log(refDataGrid.current?.instance.getDataSource())

              // var res = refDataGrid.current?.instance.getDataSource()
              // // res.filter(["ID", "=", "0"], "AND", ["Cond", "=", ""]);
              // refDataGrid.current?.instance.option('dataSource', []);

              // res.reload();
              // console.log(refDataGrid.current?.instance.getDataSource())

              hideLoadPanel();
              console.log(error);
            });
        })
        .catch((error) => {
          hideLoadPanel();
          console.log(error);
        });
    } else {
      await httpRequest(
        "POST",
        requestsApi.getDataEntity,
        requestsApi.basicAuth,
        {
          applicationId: applicationID,
          entityName: props.entityNameGrid,
          fieldName: props.estruturaDaEntidadeDetalhe.keyFieldName,
          expressao: props.masterEntityId,
        }
      )
        .then((senderGetDataEntity) => {
          const resultGetDataEntity = JSON.parse(senderGetDataEntity);

          convertDate(
            resultGetDataEntity.masterEntity[0]?.records,
            props.colunasArray
          );
          setDataSourceAtualState(resultGetDataEntity.masterEntity[0]?.records);

          hideLoadPanel();
        })
        .catch((error) => {
          // setDataSourceAtualState([])
          // console.log(refDataGrid.current?.instance.getDataSource())
          // var res = refDataGrid.current?.instance.getDataSource()
          // res.filter(["ID", "=", "0"], "AND", ["Cond", "=", ""])
          // res.reload();
          // refDataGrid.current?.instance.refresh()
          // console.log(refDataGrid.current?.instance.getDataSource())
          hideLoadPanel();
          console.log(error);
        });
    }
  };

  const actionExportExcel = useCallback(() => {
    if (refDataGrid) {
      ExportingExcel(refDataGrid, props.caption);
    }
  }, []);

  const convertNumberToCurrency = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });

  function onCellPreparedFunctionColor(e, item) {
    changeDataRowColor(e, item?.rowColor);
  }

  const getOcorrencias = () => {
    if (widgetsTeleCob?.length > 0) {
      for (let c = 0; c <= widgetsTeleCob.length - 1; c++) {
        if (widgetsTeleCob[c]?.widget === "tabulacaoAcionamento") {
          setOcorrenciasStates(widgetsTeleCob[c]?.ocorrencias);
          //codigo para abrir popup do ocorrencias
          setHistoricoCustomFormPopupVisibleState(true);
        }
      }
    } else {
      const dataSouce = props.dataEntity?.masterEntity?.[0]?.records?.[0];

      const getWidgetFunction = (getWidgetArraySessionStorage) => {
        httpRequest("POST", requestsApi.getWidget, requestsApi.basicAuth, {
          applicationId: applicationID,
          equipeId: props.equipeId,
          credorId: props.credorId,
          receptivo:
            JSON.parse(sessionStorage.getItem("mensagemSocket"))
              ?.descricaoMailling?.length === 0
              ? 1
              : 0,
        })
          .then((sender) => {
            const getWidgetsResult = JSON.parse(sender);
            for (let c = 0; c <= getWidgetsResult.length - 1; c++) {
              if (getWidgetsResult[c]?.widget === "tabulacaoAcionamento") {
                setOcorrenciasStates(getWidgetsResult[c]?.ocorrencias);
                //codigo para abrir popup do ocorrencias
                setHistoricoCustomFormPopupVisibleState(true);
              }
            }
            // setGravouOcorrencia(false)

            const getWidgetsResultArray = [
              {
                credorId: props.credorId,
                receptivo:
                  JSON.parse(sessionStorage.getItem("mensagemSocket"))
                    ?.descricaoMailling?.length === 0
                    ? 1
                    : 0,
                getWidgetsResult: getWidgetsResult,
              },
            ];

            // if (getWidgetArraySessionStorage) {
            //   const arrayFinal = getWidgetArraySessionStorage.concat(
            //     getWidgetsResultArray
            //   );
            //   setGetWidgetArrayGlobalState(arrayFinal);
            // } else {
            //   setGetWidgetArrayGlobalState(getWidgetsResultArray);
            // }
          })
          .catch((err) => {
            console.log(err);
            setPopupErrorMessageState(err?.data?.err);
            setPopupErrorVisibleState(true);
          });
      };

      // if (getWidgetArrayGlobalState?.length > 0) {
      //   const getWidgetArray = getWidgetArrayGlobalState;

      //   const mensagemSocket = JSON.parse(
      //     sessionStorage.getItem("mensagemSocket")
      //   );
      //   const receptivoValue =
      //     mensagemSocket?.descricaoMailling?.length === 0 ? 1 : 0;

      //   const widget = getWidgetArray.find(
      //     (e) =>
      //       e?.credorId === props.credorId && e?.receptivo === receptivoValue
      //   );

      //   const getWidgetsResult = widget?.getWidgetsResult;

      //   if (getWidgetsResult) {
      //     for (let c = 0; c <= getWidgetsResult.length - 1; c++) {
      //       if (getWidgetsResult[c]?.widget === "tabulacaoAcionamento") {
      //         setOcorrenciasStates(getWidgetsResult[c]?.ocorrencias);
      //         //codigo para abrir popup do ocorrencias
      //         setHistoricoCustomFormPopupVisibleState(true);
      //       }
      //     }
      //   } else {
      //     getWidgetFunction(getWidgetArray);
      //   }
      // } else {
        getWidgetFunction();
      // }
    }
  };

  const getOcorrenciasTarefa = () => {
    httpRequest("POST", requestsApi.getDataEntity, requestsApi.basicAuth, {
      entityName: "_ocorrenciaTarefa",
      fieldName: "*",
      expressao: "*",
      applicationId: applicationID,
    })
      .then((sender) => {
        const resultGetDataEntityJson = JSON.parse(sender);
        setOcorrenciasStates(
          resultGetDataEntityJson?.masterEntity?.[0]?.records
        );
        //codigo para abrir popup do ocorrencias
        setTarefaHistoricoFormPopupVisibleState(true);
      })
      .catch((err) => {
        console.log(err);
        setPopupErrorMessageState(err?.data?.err);
        setPopupErrorVisibleState(true);
      });
  };

  const [ocorrenciasState, setOcorrenciasStates] = useState();

  const RenderHistoricoCustomFormPopup = memo(() => {
    return (
      <HistoricoCustomFormPopup
        visibleState={historicoCustomFormPopupVisibleState}
        functionVisibleState={setHistoricoCustomFormPopupVisibleState}
        tituloId={props.tituloId ? props.tituloId : props.idValue}
        ocorrencias={ocorrenciasState}
        toastConfiguration={toastConfiguration}
        clienteId={props.clienteid}
      />
    );
  });

  const RenderTarefaHistoricoFormPopup = memo(() => {
    return (
      <TarefaHistoricoFormPopup
        visibleState={tarefaHistoricoFormPopupVisibleState}
        functionVisibleState={setTarefaHistoricoFormPopupVisibleState}
        tituloId={props.tituloId ? props.tituloId : props.idValue}
        ocorrencias={ocorrenciasState}
        toastConfiguration={toastConfiguration}
      />
    );
  });

  const onClickMenuContextItem = (item) => {
    if (!item.itemData?.askConfirm) {
      // props.setReloadTabPanelDetailState(!props.reloadTabPanelDetailState)
      // SetTabPanelDetailEntityItemState(false)
      const selectedRowsData = refDataGrid.current
        ?.instance
        .getSelectedRowsData();

      setSelectedItens(selectedRowsData);
      setSelectedItensCount(selectedRowsData.length);

      if (
        item.itemData.componentName === "recordForm" &&
        selectedRowsData[0][item?.itemData?.idFieldName] &&
        selectedRowsData?.length === 1
      ) {
        showLoadPanel();
        httpRequest(
          "POST",
          requestsApi.getEntityStructure,
          requestsApi.basicAuth,
          {
            entityName: item.itemData.componentParameter,
            applicationId: applicationID,
          }
        )
          .then((sender) => {
            const resultGetEntityStructureJson = JSON.parse(sender);

            if (resultGetEntityStructureJson?.[0]?.lookUpEntities?.length > 0) {
              showLoadPanel();
              httpRequest(
                "POST",
                requestsApi.getLookupTable,
                requestsApi.basicAuth,
                {
                  lookUpEntities:
                    resultGetEntityStructureJson?.[0]?.lookUpEntities,
                }
              )
                .then((sender) => {
                  const senderDataLookup = JSON.parse(sender);
                  hideLoadPanel();
                  setTabPanelItems([
                    ...tabPanelItems,
                    {
                      title: `${resultGetEntityStructureJson[0].masterEntity.caption}`,
                      // ,icon: itemClicado.itemData.icon
                      component: (
                        <ScrollView width="100%" height="100%">
                          <RecordForm
                            entityName={item.itemData.componentParameter}
                            idValue={
                              selectedRowsData[0][item.itemData.idFieldName]
                            }
                            dataLookup={senderDataLookup}
                            entityStructure={resultGetEntityStructureJson}
                          />
                        </ScrollView>
                      ),
                      text: Math.random(),
                    },
                  ]);
                  setIndexTabPanelMain(tabPanelItems.length);
                })
                .catch((error) => {
                  console.log(error);
                  hideLoadPanel();
                });
            } else {
              hideLoadPanel();
              setTabPanelItems([
                ...tabPanelItems,
                {
                  title: `${resultGetEntityStructureJson[0].masterEntity.caption}`,
                  // ,icon: itemClicado.itemData.icon
                  component: (
                    <ScrollView width="100%" height="100%">
                      <RecordForm
                        entityName={item.itemData.componentParameter}
                        idValue={selectedRowsData[0][item.itemData.idFieldName]}
                        entityStructure={resultGetEntityStructureJson}
                      />
                    </ScrollView>
                  ),
                  text: Math.random(),
                },
              ]);
              setIndexTabPanelMain(tabPanelItems.length);
            }
            if (item?.entityRefresh === 1) {
              refreshDetailEntity(
                props.entityNameGrid,
                props.estruturaDaEntidadeDetalhe.keyFieldName
              );
            }
          })
          .catch((error) => {
            console.log(error);
            hideLoadPanel();
          });
      }

      //CODIGO PARA QUANDO CLICAR COM O BOTÃO DIREITO ABRA O GERAR ACORDO
      // else if(sender.itemData.componentName === "gerarAcordo") {
      //     setTabPanelItems([
      //         ...tabPanelItems,
      //         {
      //             title: `${sender.itemData.componentParameter}`
      //             // ,icon: itemClicado.itemData.icon
      //             ,component:
      //                 <ScrollView  width='100%' height='100%'>
      //                         <GerarAcordoForm
      //
      //                         />
      //                 </ScrollView>
      //             ,text: Math.random()
      //         }
      //     ])
      //     setIndexTabPanelMain(tabPanelItems.length)
      // }
      else if (item.itemData.componentName === "gerarBoletoForm") {
        let parcelasIdArray = [];

        for (let a = 0; a <= selectedRowsData?.length - 1; a++) {
          parcelasIdArray.push(selectedRowsData[a].id);
        }
        let dataBoletoForm = props.dataEntity?.masterEntity?.[0]?.records?.[0];
        props.showUpfPopupForm(
          props.clienteid,
          props.credorId,
          props.tituloId, //tituloId
          "Boleto",
          item._execute,
          parcelasIdArray
        );
      } else if (item.itemData.componentName === "gerarAcordoForm") {
        let parcelasIdArray = [];

        for (let a = 0; a <= selectedRowsData?.length - 1; a++) {
          parcelasIdArray.push(selectedRowsData[a].id);
        }

        let dataAcordoForm = props.dataEntity?.masterEntity?.[0]?.records?.[0];
        props.showUpfPopupForm(
          props.clienteid,
          props.credorId,
          props.tituloId, //tituloId
          "Acordo/Novação de dívida",
          item._execute,
          parcelasIdArray
        );
      } else if (item.itemData.componentName === "htmlForm") {
        let idValueJson = [];

        for (let a = 0; a <= selectedRowsData?.length - 1; a++) {
          idValueJson.push(selectedRowsData[a].id);
        }
        showLoadPanel();
        httpRequest(
          "POST",
          `${requestsApi.customUrl}${item.itemData.methodName}`,
          requestsApi.basicAuth,
          {
            applicationId: applicationID,
            relationId: relationId,
            idValue: idValueJson[0],
            parameter: item.itemData.componentParameter,
            entityName: props.entityNameGrid,
          }
        )
          .then((sender) => {
            const resultJsonTemplateHtml = JSON.parse(sender);
            toastConfiguration(true, "success", "Arquivo gerado com sucesso!");
            hideLoadPanel();
            setHtmlTemplate(() => {
              return {
                __html: resultJsonTemplateHtml[0].html,
                clienteid: resultJsonTemplateHtml[0]?.clienteId,
                resultJsonTemplateHtml: resultJsonTemplateHtml[0]
              };
            });
            setHtmlFormPopupDataSourceState(item.itemData.componentParameter);
            setHtmlFormPopupIdState(idValueJson[0]);
            setHtmlPopupVisible(true);
            setHtmlPopupEntityNameState(props.entityNameGrid);
            if (item?.entityRefresh === 1) {
              refreshDetailEntity(
                props.entityNameGrid,
                props.estruturaDaEntidadeDetalhe.keyFieldName
              );
            }
          })
          .catch((error) => {
            console.log(error);
            hideLoadPanel();
            if (error?.data?.error) {
              hideLoadPanel();
              setPopupStates({
                visible: true,
                message: error.data.error,
              });
            }
          });
      } else if (item.itemData.methodName) {
        let idValueJson = [];

        for (let a = 0; a <= selectedRowsData?.length - 1; a++) {
          idValueJson.push(selectedRowsData[a].id);
        }
        showLoadPanel();
        httpRequest(
          "POST",
          `${requestsApi.customUrl}${item.itemData.methodName}`,
          requestsApi.basicAuth,
          {
            applicationId: applicationID,
            relationId: relationId,
            idValue: idValueJson,
            parameter: item.itemData.componentParameter,
            entityName: props.entityNameGrid,
          }
        )
          .then((sender) => {
            hideLoadPanel();
            const itemSelecionadoDataGrid = refDataGrid?.current
              ?.instance
              ?.getSelectedRowsData();
            if (item.itemData.componentParameter === "_contextGridClickToCall" && itemSelecionadoDataGrid?.[0]?._cryptfone) {
              // setHistoricoCustomFormPopupGlobalState({
              //   ...historicoCustomFormPopupGlobalState,
              //   telefone: itemSelecionadoDataGrid?.[0]?._cryptfone,
              // });
            }
            const response = JSON.parse(sender);
            toastConfiguration(true, "info", response.mensagem);
            refreshDetailEntity(
              props.entityNameGrid,
              props.estruturaDaEntidadeDetalhe.keyFieldName
            );
            if (item?.entityRefresh === 1) {
              refreshDetailEntity(
                props.entityNameGrid,
                props.estruturaDaEntidadeDetalhe.keyFieldName
              );
            }
          })
          .catch((error) => {
            hideLoadPanel();
            if (error?.data?.error) {
              hideLoadPanel();
              setPopupStates({
                visible: true,
                message: error.data.error,
              });
            }
          });
      }
    } else {
      setContextMenuItemState(item);
      setVisibleConfirmContextMenuState(true);
    }
  };

  const openMenuContextFunction = (e) => {
    let entityNameDetailEntity = props.entityNameGrid;

    if (props.contextMenu !== null && e.row.data) {
      let menuContextArray = [];
      for (let c = 0; c <= props.contextMenu?.length - 1; c++) {
        let contextMenuItem = {
          text: props.contextMenu[c].caption,
          icon: props.contextMenu[c].icon,
          onItemClick: onClickMenuContextItem,
          componentName: props.contextMenu[c].componentName,
          componentParameter: props.contextMenu[c].componentParameter,
          idFieldName: props.contextMenu[c].idFieldName,
          methodName: props.contextMenu[c].methodName,
          askConfirm: props.contextMenu[c].askConfirm,
        };

        let permissoesItemContextMenu = validatePermission(
          props.contextMenu[c]?.objectid
        );
        // if(permissoesItemContextMenu?._execute === 0){
        //     // contextMenu[c]["disabled"] = true
        //     console.log(contextMenu[c])
        // }

        props.contextMenu[c]["_execute"] = permissoesItemContextMenu?._execute;

        if (
          permissoesItemContextMenu?._show === 1 &&
          props.contextMenu[c]?.gridVisible === 1
        ) {
          const nomeCampoCondicionalVisivel =
            props.contextMenu[c].conditionalVisibleFieldName?.toLowerCase();
          let valorCampoCondicionalVisivel =
            props.contextMenu[c].conditionalVisibleFieldValue;

          if (nomeCampoCondicionalVisivel && valorCampoCondicionalVisivel) {
            if (valorCampoCondicionalVisivel?.includes(",")) {
              valorCampoCondicionalVisivel = valorCampoCondicionalVisivel
                .split(",")
                .map((s) => s.trim());
            }
            if (Array.isArray(valorCampoCondicionalVisivel)) {
              for (
                let i = 0;
                i <= valorCampoCondicionalVisivel.length - 1;
                i++
              ) {
                if (
                  e?.row?.data[`${nomeCampoCondicionalVisivel}`] ===
                  valorCampoCondicionalVisivel[i]
                ) {
                  menuContextArray.push(contextMenuItem);
                }
              }
            } else {
              if (
                e?.row?.data[`${nomeCampoCondicionalVisivel}`] ===
                valorCampoCondicionalVisivel
              ) {
                menuContextArray.push(contextMenuItem);
              }
            }
          } else {
            menuContextArray.push(contextMenuItem);
          }
        }
      }

      if (
        e.target === "content" &&
        refDataGrid.current?.instance.getSelectedRowsData()?.length > 0
      ) {
        if (e.row) {
          if (e.row.rowType === "data") {
            e.items = menuContextArray;
          }
        }
      }
    }
  };

  const fieldsPermissionUpdateArray = [];

  // useEffect(() => {
  //     console.log(props.dataEntityDetailEntity.find((e) => e.entityName === props.entityNameGrid))
  //     console.log(props.entityNameGrid)
  // }, [props.dataEntityDetailEntity])

  const handleBatchSave = (e) => {
    const insertArr = [];
    const updateArr = [];
    const removeArr = [];

    const requestTypes = {
      insert: (i) => {
        const jsonDataInsert = i.data;
        delete jsonDataInsert.id;
        const insertFormData = {
          ...jsonDataInsert,
          [props.estruturaDaEntidadeDetalhe.keyFieldName]:
            props?.masterEntityId,
        };
        insertArr.push(insertFormData);
      },
      update: (i) => {
        const dataObjPermissionUpdate = {
          id: i.key,
        };

        const fieldsNotPermissionUpdateArray = [];

        const jsonDataUpdate = i.data;
        // delete jsonDataUpdate.id;

        const dataKeysArray = Object.keys(jsonDataUpdate);

        for (let c = 0; c <= dataKeysArray.length - 1; c++) {
          if (fieldsPermissionUpdateArray.find((e) => e === dataKeysArray[c])) {
            dataObjPermissionUpdate[dataKeysArray[c]] =
              jsonDataUpdate[dataKeysArray[c]];
          } else {
            fieldsNotPermissionUpdateArray.push(dataKeysArray[c]);
          }
        }

        if (Object.keys(dataObjPermissionUpdate)?.length > 1) {
          updateArr.push(dataObjPermissionUpdate);
        }
        // else {
        //     refreshDetailEntity(props.entityNameGrid, props.estruturaDaEntidadeDetalhe.keyFieldName);
        // }

        if (fieldsNotPermissionUpdateArray.length > 0) {
          let mensagemErroCamposSemPermissao = "Não foi possível atualizar ";

          for (let c = 0; c <= fieldsNotPermissionUpdateArray.length - 1; c++) {
            mensagemErroCamposSemPermissao =
              mensagemErroCamposSemPermissao +
              fieldsNotPermissionUpdateArray[c] +
              ", ";
          }

          mensagemErroCamposSemPermissao =
            mensagemErroCamposSemPermissao + "pois usuário não tem permissão.";
          setPopupStates({
            visible: true,
            message: mensagemErroCamposSemPermissao,
          });
        }
      },
      remove: (i) => {
        const removeFormData = {
          ...i.data,
          id: i.key,
        };
        removeArr.push(removeFormData);
      },
    };

    for (let i of e.changes) {
      if (requestTypes[i.type]) {
        requestTypes[i.type](i);
      }
    }

    // * Faz a requisição para inserts e updates em lote
    if (insertArr.length > 0) {
      recordInsertJsonDetail(props.entityNameGrid, insertArr, refDataGrid);
    }
    if (updateArr.length > 0) {
      recordUpdateJsonDetail(props.entityNameGrid, updateArr, refDataGrid);
    }

    // * Só faz o refresh se tiver algum insert ou delete
    if (insertArr.length > 0 || removeArr.length > 0) {
      refreshDetailEntity(
        props.entityNameGrid,
        props.estruturaDaEntidadeDetalhe.keyFieldName
      );
    }

    setModeEditDataGrid({
      edit: false,
    });
  };

  const onRowInserting = (e) => {
    if (Object.keys(e.data).length === 0) {
      e.cancel = true;
      notify(
        { message: "Não é permitido adicionar registros vazios" },
        "error",
        1500
      );
    }
  };

  const onRowRemoved = (e) => {
    recordDeleteJsonDetail(props.entityNameGrid, e.key);
    refreshDetailEntity(
      props.entityNameGrid,
      props.estruturaDaEntidadeDetalhe.keyFieldName
    );
    setModeEditDataGrid({
      edit: false,
    });
  };

  const onEditorPreparing = (e) => {
    if (e.editorName === "dxCheckBox") {
      e.editorOptions.value = e.value === null ? false : e.value;
    }
  };

  const onCellPrepared = (e) => {
    onCellPreparedFunctionColor(e, props.estruturaDaEntidadeDetalhe);
  };

  const onRowDblClick = (item) => {
    if (!modeEditDataGrid.edit && props.itemPermissions?._show === 1) {
      if (props.estruturaDaEntidadeDetalhe?.customRecordForm === "boletoForm") {
        //codigo para chamar o ConsultaBoletoForm

        //pegar as lookups
        httpRequest("POST", requestsApi.getLookupTable, requestsApi.basicAuth, {
          lookUpEntities: [
            {
              lookUpEntity: "TipoNegociacao",
            },
            {
              lookUpEntity: "OpcaoNegociacao",
            },
            {
              lookUpEntity: "_tipo_contato",
            },
            {
              lookUpEntity: "_pontuacao_contato",
            },
          ],
        })
          .then((sender) => {
            const resultGetLookupTableJson = JSON.parse(sender);

            //para pegar o email do cliente
            httpRequest(
              "POST",
              requestsApi.getEntityRecords,
              requestsApi.basicAuth,
              {
                applicationId: applicationID,
                entityName: "_cadastro",
                fieldName: "id",
                expressao: props.clienteid,
              }
            )
              .then((sender) => {
                const resultSenderJsonCliente = JSON.parse(sender);

                //para pegar os telefones
                httpRequest(
                  "POST",
                  requestsApi.getEntityRecords,
                  requestsApi.basicAuth,
                  {
                    applicationId: applicationID,
                    entityName: "_cadastro_contatos",
                    fieldName: "_cadastro_id",
                    expressao: props.clienteid,
                  }
                )
                  .then((sender) => {
                    const resultSenderJsonTelefones = JSON.parse(sender);

                    setDataSourceBoletoState({
                      ...dataSourceBoletoState,
                      telefones: resultSenderJsonTelefones.records,
                      boleto: item.data.id,
                      email: resultSenderJsonCliente.records[0]._cryptemail,
                      dataLookup: resultGetLookupTableJson,
                      masterEntityId: props.clienteid,
                    });

                    setConsultaBoletoFormPopupState(true);
                  })
                  .catch((err) => {
                    console.log(err);
                    //gerou boleto porem n tem contatos
                    setDataSourceBoletoState({
                      ...dataSourceBoletoState,
                      telefones: [],
                      boleto: item.data.id,
                      email: resultSenderJsonCliente.records[0]._cryptemail,
                      dataLookup: resultGetLookupTableJson,
                      masterEntityId: props.clienteid,
                    });

                    setConsultaBoletoFormPopupState(true);
                  });
              })
              .catch((err) => {
                console.log(err);
                //gerou boleto porem n tem contatos
                setDataSourceBoletoState({
                  ...dataSourceBoletoState,
                  telefones: [],
                  boleto: item.data.id,
                  email: "",
                  dataLookup: resultGetLookupTableJson,
                  masterEntityId: props.clienteid,
                });

                props.setConsultaBoletoFormPopupState(true);
              });
          })
          .catch((error) => {
            console.log(error);
            // setMessage(error.data.error)
            // setVisible(true)
          });
      } else if (
        props.estruturaDaEntidadeDetalhe?.customRecordForm === "historicoForm"
      ) {
        props.setHistoricoCustomFormPopupVisibleState(true);
      } else {
        httpRequest(
          "POST",
          requestsApi.getEntityStructure,
          requestsApi.basicAuth,
          {
            applicationId: applicationID,
            entityName: props.entityNameGrid,
          }
        ).then((sender) => {
          const resultGetEntityStructureJson = JSON.parse(sender);

          props.setEntityStructureRecordFormPopupState(
            resultGetEntityStructureJson
          );

          if (resultGetEntityStructureJson?.[0]?.lookUpEntities?.length > 0) {
            if (props.objectLookUpEntityViewsTipoProcessamento) {
              const lookUpEntityViewsTipoProcessamento =
                resultGetEntityStructureJson[0]?.lookUpEntities.find(
                  (e) => e.lookUpEntity === "viewstipoprocessamentolookup"
                );

              if (lookUpEntityViewsTipoProcessamento) {
                resultGetEntityStructureJson[0]?.lookUpEntities.splice(
                  resultGetEntityStructureJson[0]?.lookUpEntities.indexOf(
                    lookUpEntityViewsTipoProcessamento
                  ),
                  1,
                  props.objectLookUpEntityViewsTipoProcessamento
                );
              } else {
                resultGetEntityStructureJson[0]?.lookUpEntities?.push(
                  props.objectLookUpEntityViewsTipoProcessamento
                );
              }
            }

            httpRequest(
              "POST",
              requestsApi.getLookupTable,
              requestsApi.basicAuth,
              {
                lookUpEntities:
                  resultGetEntityStructureJson?.[0]?.lookUpEntities,
              }
            )
              .then((sender) => {
                const senderDataLookup = JSON.parse(sender);
                props.setDataLookupRecordFormPopupState(senderDataLookup);

                props.setIDValueDetailEntity(item.data.id);
                props.setDetailEntityName(props.entityNameGrid);
                props.setDetailCaptionName(
                  props.estruturaDaEntidadeDetalhe.caption
                );
                props.setPopupRecordFormOpen(true);
                props.setPopupState(true);
                props.setPopupRecordFormAdd(false);
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            props.setIDValueDetailEntity(item.data.id);
            props.setDetailEntityName(props.entityNameGrid);
            props.setDetailCaptionName(
              props.estruturaDaEntidadeDetalhe.caption
            );
            props.setPopupRecordFormOpen(true);
            props.setPopupState(true);
            props.setPopupRecordFormAdd(false);
          }
        });
      }
    } else if (!modeEditDataGrid?.edit) {
      setPopupStates({
        visible: true,
        message: "Usuário não tem permissão!",
      });
      props.setMessageError("Usuário não tem permissão!");
      props.setPopup({
        ...props.popup,
        isVisible: true,
        message: "Atenção!",
      });
    }
  };

  const onSelectionChanged = (e) => e.component.refresh(true);

  const addRow = useCallback(() => {
    refDataGrid.current?.instance.addRow();
    refDataGrid.current?.instance.deselectAll();
  }, [refDataGrid]);

  return (
    <>
      {props.itemPermissions?._edit === 1 ||
      props.itemPermissions?._insert === 1 ? (
        <div className="btn-tabPanel">
          <div className="buttons-tabpanel">
            <Button
              icon="add"
              hint={`Incluir um novo registro em ${props.estruturaDaEntidadeDetalhe?.caption}`}
              visible={
                props.itemPermissions ? props.itemPermissions?._insert : false
              }
              type="normal"
              onClick={() => {
                if (modeEditDataGrid.edit) {
                  addRow();
                } else {
                  if (
                    props.estruturaDaEntidadeDetalhe?.customInsertRecordForm ===
                    "gerarBoletoForm"
                  ) {
                    let dataBoletoForm =
                      props.dataEntity?.masterEntity?.[0]?.records?.[0];
                    props.showUpfPopupForm(
                      props.clienteid,
                      props.credorId,
                      props.tituloId, // tituloId
                      "Boleto"
                    );
                  }
                  if (
                    props.estruturaDaEntidadeDetalhe?.customInsertRecordForm ===
                    "historicoForm"
                  ) {
                    getOcorrencias();
                  } else if (
                    props.estruturaDaEntidadeDetalhe?.customInsertRecordForm ===
                    "tarefaHistoricoForm"
                  ) {
                    getOcorrenciasTarefa();
                  } else if (
                    props.estruturaDaEntidadeDetalhe?.customInsertRecordForm ===
                    "gerarBoletoForm"
                  ) {
                    let dataBoletoForm =
                      props.dataEntity?.masterEntity?.[0]?.records?.[0];
                    props.showUpfPopupForm(
                      props.clienteid,
                      props.credorId,
                      props.tituloId, //tituloId
                      "Boleto"
                    );
                  } else {
                    httpRequest(
                      "POST",
                      requestsApi.getEntityStructure,
                      requestsApi.basicAuth,
                      {
                        entityName: props.entityNameGrid,
                        applicationId: applicationID,
                      }
                    )
                      .then((sender) => {
                        props.setEntityStructureRecordFormPopupState(
                          JSON.parse(sender)
                        );

                        const resultGetEntityStructureJson = JSON.parse(sender);

                        if (
                          resultGetEntityStructureJson?.[0]?.lookUpEntities
                            ?.length > 0
                        ) {
                          if (props.objectLookUpEntityViewsTipoProcessamento) {
                            const lookUpEntityViewsTipoProcessamento =
                              resultGetEntityStructureJson[0]?.lookUpEntities.find(
                                (e) =>
                                  e.lookUpEntity ===
                                  "viewstipoprocessamentolookup"
                              );

                            if (lookUpEntityViewsTipoProcessamento) {
                              resultGetEntityStructureJson[0]?.lookUpEntities.splice(
                                resultGetEntityStructureJson[0]?.lookUpEntities.indexOf(
                                  lookUpEntityViewsTipoProcessamento
                                ),
                                1,
                                props.objectLookUpEntityViewsTipoProcessamento
                              );
                            } else {
                              resultGetEntityStructureJson[0]?.lookUpEntities?.push(
                                props.objectLookUpEntityViewsTipoProcessamento
                              );
                            }
                          }

                          httpRequest(
                            "POST",
                            requestsApi.getLookupTable,
                            requestsApi.basicAuth,
                            {
                              lookUpEntities:
                                resultGetEntityStructureJson?.[0]
                                  ?.lookUpEntities,
                            }
                          )
                            .then((sender) => {
                              props.setDataLookupRecordFormPopupState(
                                JSON.parse(sender)
                              );

                              props.setKeyFieldNameState(
                                props.estruturaDaEntidadeDetalhe.keyFieldName
                              );
                              props.setIDValueDetailEntity(null);
                              props.setDetailEntityName(props.entityNameGrid);
                              props.setDetailCaptionName(
                                props.estruturaDaEntidadeDetalhe.caption
                              );
                              props.setPopupRecordFormOpen(true);
                              props.setPopupState(true);
                              props.setStateModeEdit(true);
                            })
                            .catch((error) => {
                              console.log(error);
                            });
                        } else {
                          props.setKeyFieldNameState(
                            props.estruturaDaEntidadeDetalhe.keyFieldName
                          );
                          props.setIDValueDetailEntity(null);
                          props.setDetailEntityName(props.entityNameGrid);
                          props.setDetailCaptionName(
                            props.estruturaDaEntidadeDetalhe.caption
                          );
                          props.setPopupRecordFormOpen(true);
                          props.setPopupState(true);
                          props.setStateModeEdit(true);
                        }
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                  }
                }
              }}
            />
          </div>

          <div className="buttons-tabpanel">
            <Button
              icon="rowproperties"
              hint="Editar registros em lote no grid"
              type="normal"
              visible={
                props.itemPermissions ? props.itemPermissions?._edit : false
              }
              onClick={() => {
                setModeEditDataGrid({
                  edit: !modeEditDataGrid.edit,
                });
              }}
            />
          </div>

          <div className="buttons-tabpanel">
            <Button
              icon="refresh"
              hint="Atualizar dados do servidor"
              type="normal"
              onClick={() => {
                refreshDetailEntity(
                  props.entityNameGrid,
                  props.estruturaDaEntidadeDetalhe.keyFieldName
                );
                // refDataGrid.current?.instance.refresh();
              }}
            />
          </div>

          <div className="buttons-tabpanel">
            <Button
              icon="columnchooser"
              hint="Mostrar ou esconder colunas do grid"
              type="normal"
              visible={
                props.itemPermissions
                  ? props.itemPermissions?._colchooser
                  : false
              }
              onClick={() => {
                refDataGrid.current?.instance.showColumnChooser();
              }}
            />
          </div>

          {props.estruturaDaEntidadeDetalhe.excelExport === 1 && (
            <div className="buttons-tabpanel">
              <Button
                visible={
                  props.itemPermissions ? props.itemPermissions?._excel : false
                }
                icon="exportxlsx"
                hint={`Exportar para Excel`}
                type="normal"
                onClick={() => {
                  actionExportExcel();
                }}
              />
            </div>
          )}

          <div className="buttons-tabpanel">
            <Button
              icon="textdocument"
              hint={`Log`}
              type="normal"
              visible={
                props.itemPermissions ? props.itemPermissions?._log : false
              }
              onClick={() => {
                openLogCustomForm(
                  props.estruturaDaEntidadeDetalhe,
                  dataSourceAtualState
                );
              }}
            />
          </div>

          <div className="buttons-tabpanel">
            <Button
              icon="preferences"
              visible={
                props.itemPermissions
                  ? props.itemPermissions?._configure
                  : false
              }
              hint={`Configurar o formulário de ${props.estruturaDaEntidadeDetalhe.caption}`}
              type="normal"
              onClick={() => {
                configRecordFormStructureDetail(
                  props.estruturaDaEntidadeDetalhe.keyFieldName,
                  props.entityNameGrid
                );
              }}
            />
          </div>

          {modeEditDataGrid.edit && (
            <>
              <div className="buttons-tabpanel">
                <Button
                  icon="save"
                  hint="Salvar todas as alterações"
                  type="normal"
                  onClick={() => {
                    refDataGrid.current?.instance.saveEditData();
                  }}
                />
              </div>

              <div className="buttons-tabpanel">
                <Button
                  icon="revert"
                  hint="Descartar alterações"
                  type="normal"
                  onClick={() => {
                    refDataGrid.current?.instance.cancelEditData();
                  }}
                />
              </div>
            </>
          )}
        </div>
      ) : null}

      {historicoCustomFormPopupVisibleState === true ? (
        <RenderHistoricoCustomFormPopup />
      ) : (
        <></>
      )}

      {tarefaHistoricoFormPopupVisibleState === true ? (
        <RenderTarefaHistoricoFormPopup />
      ) : (
        <></>
      )}

      {visibleConfirmContextMenuState && (
        <UpfPopupConfirmContextMenu
          hidePopupConfirmContextMenu={hidePopupConfirmContextMenu}
          visibleConfirmContextMenu={visibleConfirmContextMenuState}
          contextMenuFunction={onClickMenuContextItem}
          contextMenuItemState={contextMenuItemState}
        />
      )}
      {upfPopupCustomFormStates.visible && (
        <UpfPopupCustomForm
          entityName={upfPopupCustomFormStates.entityName}
          caption={upfPopupCustomFormStates.caption}
          idValue={upfPopupCustomFormStates.idValue}
          hideUpfPopupForm={hideUpfPopupCustomForm}
          visibleState={upfPopupCustomFormStates.visible}
          title={upfPopupCustomFormStates.title}
          formName={upfPopupCustomFormStates.formName}
          estrutura={upfPopupCustomFormStates.estrutura}
          dados={upfPopupCustomFormStates.dados}
          dataLookup={props.dataLookup}
        />
      )}
      <Toast
        position={{ at: "bottom", my: "bottom", offset: "20 -80" }}
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={onHiding}
        displayTime={3000}
        height={60}
      />
      <LoadPanel
        style={{ zIndex: "-1 !important", border: "solid 1px red !important" }}
        shadingColor="rgba(0,0,0,0.4)"
        visible={loadingPanelState.loadPanelVisible}
        // visible={true}
        showIndicator={loadingPanelState.showIndicator}
        shading={loadingPanelState.shading}
        showPane={loadingPanelState.showPane}
      />
      <UpfPopupMessage
        visible={popupStates.visible}
        hidePopup={hidePopup}
        message={popupStates.message}
      />

      <UpfPopupMessage
        hidePopup={hidePopupError}
        visible={popupErrorVisibleState}
        message={popupErrorMessageState}
      />

      <HtmlFormPopup
        setHtmlPopupVisible={setHtmlPopupVisible}
        htmlPopupVisible={htmlPopupVisible}
        htmlTemplate={htmlTemplate}
        htmlFormPopupDataSourceState={htmlFormPopupDataSourceState}
        clienteid={htmlTemplate?.clienteid}
        id={htmlFormPopupIdState}
        entityName={htmlPopupEntityNameState}
      />
      {dataSourceBoletoState && (
        <Popup
          visible={consultaBoletoFormPopupState}
          onHiding={() => {
            setConsultaBoletoFormPopupState(false);
          }}
          dragEnabled={false}
          fullScreen={true}
          closeOnOutsideClick={false}
          animation={null}
          // deferRendering={false}
          // title={props.entityStructure[0].masterEntity.caption}
          showCloseButton={true}
          showTitle={true}
          title="Boleto"
          id="popupForm"
        >
          <ScrollView width="100%" height="100%">
            <ConsultaBoletoForm
              boletoId={dataSourceBoletoState?.boleto}
              email={dataSourceBoletoState?.email}
              telefones={dataSourceBoletoState?.telefones}
              dataLookup={dataSourceBoletoState?.dataLookup}
              masterEntityId={dataSourceBoletoState?.masterEntityId}
              dataSourceBoletoState={dataSourceBoletoState}
              consultaBoletoFormPopupState={consultaBoletoFormPopupState}
            />
          </ScrollView>
        </Popup>
      )}
      <DataGrid
        keyExpr="id"
        className="datagrid-detail-entity"
        dataSource={dataSourceAtualState}
        ref={refDataGrid}
        errorRowEnabled={false}
        repaintChangesOnly={true}
        //repaintChangesOnly={true} (pode afetar a performance) comentado 17/05/2022, pois quando agrupava no grid e tentava editar e depois salvar quebrava o groupIndex
        renderAsync={true}
        allowColumnResizing={true}
        columnResizingMode={"widget"}
        columnAutoWidth={true}
        columnHidingEnabled={true}
        onRowInserting={onRowInserting}
        onRowRemoved={onRowRemoved}
        onSaving={handleBatchSave}
        onEditorPreparing={onEditorPreparing}
        onCellPrepared={onCellPrepared}
        onRowDblClick={onRowDblClick}
        onContextMenuPreparing={openMenuContextFunction}
        onSelectionChanged={onSelectionChanged}
        allowColumnReordering={true}
        showBorders={true}
        rowAlternationEnabled={true}
        focusedRowEnabled={true}
        focusedRowKey={0}
        columnMinWidth={50}
        activeStateEnabled={false}
        cacheEnabled={false}
        dateSerializationFormat="yyyy-MM-ddTHH:mm:ss"
        onEditCanceled={() => {
          setModeEditDataGrid({
            edit: false,
          });
        }}
      >
        <Selection
          keyExpr="id"
          mode="multiple"
          selectAllMode="allPages"
          showCheckBoxesMode="onClick"
        />
        <Editing
          allowDeleting={
            modeEditDataGrid.edit && props.itemPermissions?._delete
          }
          allowUpdating={modeEditDataGrid.edit && props.itemPermissions?._edit}
          // allowAdding={modeEditDataGrid.edit && props.itemPermissions?._insert}
          confirmDelete={true}
          mode="batch"
          useIcons={true}
          //selectTextOnEditStart={selectTextOnEditStart}
          //startEditAction={startEditAction}
        />
        <Column
          caption="Deletar"
          visible={modeEditDataGrid.edit && props.itemPermissions?._delete}
          type="buttons"
          width={110}
        >
          <Button name="delete" />
        </Column>
        <Scrolling
          rowRenderingMode="virtual"
          showScrollbar="always"

          // rowRenderingMode="standard"
          // mode="virtual"
        ></Scrolling>

        <Paging
          defaultPageSize={
            props.estruturaDaEntidadeDetalhe?.pagingdefaultpagesize > 0
              ? props.estruturaDaEntidadeDetalhe?.pagingdefaultpagesize
              : 10
          }
        />

        <FilterRow />

        <Sorting mode="multiple" />
        <GroupPanel
          //visible={true}
          allowColumnDragging={true}
        />
        <Grouping autoExpandAll={false} />
        <Pager
          visible={true}
          // allowedPageSizes={[10, 25, 50, 100]}
          showPageSizeSelector={true}
          showInfo={true}
          showNavigationButtons={true}
        />
        <HeaderFilter search={{ enabled: true }} visible={true} />
        {props.colunasArray.map((colunaItem, colunaIndice) => {
          const fieldPermissions = validatePermission(colunaItem.objectid);

          if (fieldPermissions?._edit === 1) {
            fieldsPermissionUpdateArray.push(colunaItem.fieldName);
          }
          if (colunaItem.editorType === "dxCheckBox") {
            return (
              <Column
                key={colunaIndice}
                fixed={colunaItem.fixed}
                visible={colunaItem.formVisible === 1}
                groupIndex={
                  !colunaItem?.groupIndex ? -1 : colunaItem?.groupIndex
                }
                defaultSortOrder={colunaItem.sortOrder}
                defaultSortIndex={colunaItem.sortIndex}
                //showInColumnChooser={colunaItem.formVisibleForCustomization === 1}
                dataField={colunaItem.fieldName}
                allowEditing={colunaItem.readOnly != 1}
                caption={colunaItem.fieldCaption}
                // editorOptions={editorOptionsColumns}
                dataType={"boolean"}
              ></Column>
            );
          } else if (
            (colunaItem.editorType === "dxDateBox" ||
              colunaItem.editorType === "dxCalendar") &&
            colunaItem.fieldType === "datetime"
          ) {
            return (
              <Column
                key={colunaIndice}
                fixed={colunaItem.fixed}
                visible={colunaItem.formVisible === 1}
                groupIndex={
                  !colunaItem?.groupIndex ? -1 : colunaItem?.groupIndex
                }
                defaultSortOrder={colunaItem.sortOrder}
                defaultSortIndex={colunaItem.sortIndex}
                //showInColumnChooser={colunaItem.formVisibleForCustomization === 1}
                dataField={colunaItem.fieldName}
                allowEditing={colunaItem.readOnly != 1}
                caption={colunaItem.fieldCaption}
                // editorOptions={editorOptionsColumns}
                dataType={colunaItem.fieldType}
                format="shortDateShortTime"
              ></Column>
            );
          } else if (colunaItem.editorType === "upfTime") {
            return (
              <Column
                key={colunaIndice}
                fixed={colunaItem.fixed}
                visible={colunaItem.formVisible === 1}
                groupIndex={
                  !colunaItem?.groupIndex ? -1 : colunaItem?.groupIndex
                }
                defaultSortOrder={colunaItem.sortOrder}
                defaultSortIndex={colunaItem.sortIndex}
                //showInColumnChooser={colunaItem.formVisibleForCustomization === 1}
                dataField={colunaItem.fieldName}
                allowEditing={colunaItem.readOnly != 1}
                caption={colunaItem.fieldCaption}
                // editorOptions={editorOptionsColumns}
                dataType={"datetime"}
                format="shortTime"
              ></Column>
            );
          } else if (
            (colunaItem.editorType === "dxDateBox" ||
              colunaItem.editorType === "dxCalendar") &&
            colunaItem.fieldType === "date"
          ) {
            return (
              <Column
                key={colunaIndice}
                fixed={colunaItem.fixed}
                visible={colunaItem.formVisible === 1}
                groupIndex={
                  !colunaItem?.groupIndex ? -1 : colunaItem?.groupIndex
                }
                defaultSortOrder={colunaItem.sortOrder}
                defaultSortIndex={colunaItem.sortIndex}
                //showInColumnChooser={colunaItem.formVisibleForCustomization === 1}
                dataField={colunaItem.fieldName}
                allowEditing={colunaItem.readOnly != 1}
                caption={colunaItem.fieldCaption}
                // editorOptions={editorOptionsColumns}
                dataType={colunaItem.fieldType}
                format="shortDate"
              ></Column>
            );
          } else if (colunaItem.editorType === "dxLookupEdit") {
            if (colunaItem.lookUpKeyField != null && props.dataLookup) {
              const newDataSource = new DataSource({
                store: {
                  data: props.dataLookup[colunaItem.lookUpListSource],
                  type: "array",
                  key: colunaItem.lookUpKeyField,
                },
              });

              const dataSourceFilter = [];
              const arrayValues = [];

              if (dataSourceAtualState?.length) {
                for (let i = 0; i <= dataSourceAtualState.length - 1; i++) {
                  if (
                    !arrayValues?.find(
                      (e) => e === dataSourceAtualState[i][colunaItem.fieldName]
                    )
                  ) {
                    arrayValues.push(
                      dataSourceAtualState[i][colunaItem.fieldName]
                    );
                  }
                }

                if (newDataSource.store()._array?.length) {
                  for (
                    let c = 0;
                    c <= newDataSource.store()._array.length - 1;
                    c++
                  ) {
                    if (
                      arrayValues?.find(
                        (e) =>
                          e ===
                          newDataSource.store()._array[c][
                            `${colunaItem.lookUpKeyField}`
                          ]
                      )
                    ) {
                      dataSourceFilter.push({
                        text: newDataSource.store()._array[c][
                          `${colunaItem.lookUpResultField}`
                        ],
                        value:
                          newDataSource.store()._array[c][
                            `${colunaItem.lookUpKeyField}`
                          ],
                      });
                    }
                  }
                }
              }

              return (
                <Column
                  key={colunaIndice}
                  fixed={colunaItem.fixed}
                  visible={colunaItem.formVisible === 1}
                  groupIndex={
                    !colunaItem?.groupIndex ? -1 : colunaItem?.groupIndex
                  }
                  defaultSortOrder={colunaItem.sortOrder}
                  defaultSortIndex={colunaItem.sortIndex}
                  //showInColumnChooser={colunaItem.formVisibleForCustomization === 1}
                  dataField={colunaItem.fieldName}
                  allowEditing={colunaItem.readOnly != 1}
                  caption={colunaItem.fieldCaption}
                  dataType={colunaItem.fieldType}
                  editorOptions={{
                    acceptCustomValue: true,
                    searchEnabled: true,
                    customItemCreateEvent: "focusout",
                    searchTimeout: 200,
                    minSearchLength: 0,
                    showDataBeforeSearch: false,
                    opened: true,
                    onCustomItemCreating: (args) => {
                      if (!args.text) {
                        args.customItem = null;
                        return;
                      } else {
                        const newItem = {};

                        newItem[colunaItem.lookUpKeyField] = args.text;
                        newItem[colunaItem.lookUpResultField] = args.text;

                        args.customItem = newDataSource
                          .store()
                          .insert(newItem)
                          .then(() => newDataSource.load())
                          .then(() => newItem)
                          .catch((error) => {
                            throw error;
                          });
                      }
                    },
                  }}
                >
                  <HeaderFilter
                    search={{
                      enabled: true,
                      mode: "contains",
                    }}
                    visible={true}
                    //searchMode='contains'
                    dataSource={dataSourceFilter}
                    key={colunaItem.lookUpKeyField}
                  />
                  <Lookup
                    // dataSource={props.dataLookup[colunaItem.lookUpListSource]}
                    dataSource={newDataSource.store()._array}
                    valueExpr={colunaItem.lookUpKeyField}
                    displayExpr={colunaItem.lookUpResultField}
                    allowClearing={true}
                    showClearButton={true}
                  />
                </Column>
              );
            }
          } else if (
            colunaItem.editorType === "dxLookup" ||
            colunaItem.editorType === "dxSelectBox"
          ) {
            if (colunaItem.lookUpKeyField != null && props.dataLookup) {
              const dataSourceFilter = [];
              const arrayValues = [];

              if (dataSourceAtualState?.length) {
                for (let i = 0; i <= dataSourceAtualState.length - 1; i++) {
                  if (
                    !arrayValues?.find(
                      (e) => e === dataSourceAtualState[i][colunaItem.fieldName]
                    )
                  ) {
                    arrayValues.push(
                      dataSourceAtualState[i][colunaItem.fieldName]
                    );
                  }
                }

                if (props.dataLookup[colunaItem.lookUpListSource]?.length) {
                  for (
                    let c = 0;
                    c <=
                    props.dataLookup[colunaItem.lookUpListSource].length - 1;
                    c++
                  ) {
                    if (
                      arrayValues?.find(
                        (e) =>
                          e ===
                          props.dataLookup[colunaItem.lookUpListSource][c][
                            `${colunaItem.lookUpKeyField}`
                          ]
                      )
                    ) {
                      dataSourceFilter.push({
                        text: props.dataLookup[colunaItem.lookUpListSource][c][
                          `${colunaItem.lookUpResultField}`
                        ],
                        value:
                          props.dataLookup[colunaItem.lookUpListSource][c][
                            `${colunaItem.lookUpKeyField}`
                          ],
                      });
                    }
                  }
                }
              }

              return (
                <Column
                  key={colunaIndice}
                  fixed={colunaItem.fixed}
                  visible={colunaItem.formVisible === 1}
                  groupIndex={
                    !colunaItem?.groupIndex ? -1 : colunaItem?.groupIndex
                  }
                  defaultSortOrder={colunaItem.sortOrder}
                  defaultSortIndex={colunaItem.sortIndex}
                  //showInColumnChooser={colunaItem.formVisibleForCustomization === 1}
                  dataField={colunaItem.fieldName}
                  allowEditing={colunaItem.readOnly != 1}
                  caption={colunaItem.fieldCaption}
                  dataType={colunaItem.fieldType}
                  filterType="include"
                  // editCellRender={
                  // format={colunaItem.fieldMask}
                  //width={colunaItem.FieldSize}
                >
                  <HeaderFilter
                    search={{
                      enabled: true,
                      mode: "contains",
                    }}
                    visible={true}
                    //searchMode='contains'
                    dataSource={dataSourceFilter}
                    key={colunaItem.lookUpKeyField}
                  />
                  <Lookup
                    dataSource={props.dataLookup[colunaItem.lookUpListSource]}
                    valueExpr={colunaItem.lookUpKeyField}
                    displayExpr={colunaItem.lookUpResultField}
                    allowClearing={true}
                    showClearButton={true}
                  />
                </Column>
              );
            }
          } else if (colunaItem.editorType === "upfLookupDetailEntity") {
            if (colunaItem.lookUpKeyField != null && props.dataEntity) {
              const dataSourceFilter = [];

              const arrayValues = [];

              const lookUpListSourceRecords = props.dataEntityDetailEntity.find(
                (element) => element.entityName === colunaItem.lookUpListSource
              )?.records;

              if (dataSourceAtualState?.length) {
                for (let i = 0; i <= dataSourceAtualState.length - 1; i++) {
                  if (
                    !arrayValues?.find(
                      (e) => e === dataSourceAtualState[i][colunaItem.fieldName]
                    )
                  ) {
                    arrayValues.push(
                      dataSourceAtualState[i][colunaItem.fieldName]
                    );
                  }
                }

                if (lookUpListSourceRecords?.length) {
                  for (
                    let c = 0;
                    c <= lookUpListSourceRecords.length - 1;
                    c++
                  ) {
                    if (
                      arrayValues?.find(
                        (e) =>
                          e ===
                          lookUpListSourceRecords[c][
                            `${colunaItem.lookUpKeyField}`
                          ]
                      )
                    ) {
                      dataSourceFilter.push({
                        text: lookUpListSourceRecords[c][
                          `${colunaItem.lookUpResultField}`
                        ],
                        value:
                          lookUpListSourceRecords[c][
                            `${colunaItem.lookUpKeyField}`
                          ],
                      });
                    }
                  }
                }
              }
              return (
                <Column
                  key={colunaIndice}
                  fixed={colunaItem.fixed}
                  visible={colunaItem.formVisible === 1}
                  groupIndex={
                    !colunaItem?.groupIndex ? -1 : colunaItem?.groupIndex
                  }
                  defaultSortOrder={colunaItem.sortOrder}
                  defaultSortIndex={colunaItem.sortIndex}
                  //showInColumnChooser={colunaItem.formVisibleForCustomization === 1}
                  dataField={colunaItem.fieldName}
                  allowEditing={colunaItem.readOnly != 1}
                  caption={colunaItem.fieldCaption}
                  dataType={colunaItem.fieldType}
                  // editCellRender={
                  // format={colunaItem.fieldMask}
                  //width={colunaItem.FieldSize}
                >
                  <HeaderFilter
                    search={{ enabled: true }}
                    visible={true}
                    searchMode="contains"
                    dataSource={dataSourceFilter}
                    key={colunaItem.lookUpKeyField}
                  />
                  <Lookup
                    dataSource={
                      props.dataEntityDetailEntity.find(
                        (element) =>
                          element.entityName === colunaItem.lookUpListSource
                      )?.records
                    }
                    valueExpr={colunaItem.lookUpKeyField}
                    displayExpr={colunaItem.lookUpResultField}
                    allowClearing={true}
                    showClearButton={true}
                  />
                </Column>
              );
            }
          }

          // else if (colunaItem.editorType === "upfLookupMasterEntity") {
          //     if (colunaItem.lookUpKeyField != null && props.dataEntity) {

          //         const resultQueryArrayLookupDataSourceEntityFieldsQuery = arrayLookupDataSourceEntityFieldsQuery
          //         // alert("upfLookupMasterEntity")
          //         // getEntityFieldsFunction()
          //         const dataSourceFilter = []
          //         const arrayValues = []

          //         if(dataSourceAtualState?.length){
          //             for(let i = 0; i <= dataSourceAtualState.length - 1; i++){
          //                 if(!arrayValues?.find((e) => e === dataSourceAtualState[i][colunaItem.fieldName])){
          //                     arrayValues.push(dataSourceAtualState[i][colunaItem.fieldName])
          //                 }
          //             }

          //             if(arrayLookupDataSourceEntityFields?.length){
          //                 for(let c = 0; c <= arrayLookupDataSourceEntityFields.length - 1; c++){
          //                     if(arrayValues?.find((e) => e === arrayLookupDataSourceEntityFields[c][`${colunaItem.lookUpKeyField}`])){
          //                         dataSourceFilter.push({
          //                             text: arrayLookupDataSourceEntityFields[c][`${colunaItem.lookUpResultField}`],
          //                             value: arrayLookupDataSourceEntityFields[c][`${colunaItem.lookUpKeyField}`],
          //                         })
          //                     }
          //                 }
          //             }
          //         }

          //         return (
          //             <Column
          //                 key={colunaIndice}
          //                 fixed={colunaItem.fixed}
          //                 visible={colunaItem.gridVisible === 1}
          //                 // groupIndex={!colunaItem?.groupIndex ? -1 : colunaItem?.groupIndex}
          //                 defaultSortOrder={colunaItem.sortOrder}
          //                 defaultSortIndex={colunaItem.sortIndex}
          //                 showInColumnChooser={colunaItem.gridVisibleForCustomization === 1}
          //                 dataField={colunaItem.fieldName}
          //                 allowEditing={colunaItem.readOnly != 1}
          //                 caption={colunaItem.fieldCaption}
          //                 dataType={colunaItem.fieldType}
          //             // editCellRender={
          //             // format={colunaItem.fieldMask}
          //             //width={colunaItem.FieldSize}
          //             >
          //                 <HeaderFilter
          //                     search={{ enabled: true }}
          //                     visible={true}
          //                     searchMode='contains'
          //                     dataSource={dataSourceFilter}
          //                     key={colunaItem.lookUpKeyField}
          //                 />
          //                 <Lookup
          //                     dataSource={arrayLookupDataSourceEntityFields}
          //                     valueExpr={colunaItem.lookUpKeyField}
          //                     displayExpr={colunaItem.lookUpResultField}
          //                     allowClearing={true}
          //                     showClearButton={true}
          //                 />

          //             </Column>
          //         )
          //     }
          // }
          else if (
            colunaItem.editorType === "upfHtmlViewer" ||
            colunaItem.editorType === "upfHtmlBox"
          ) {
            return (
              <Column
                key={colunaIndice}
                fixed={colunaItem.fixed}
                visible={colunaItem.formVisible === 1}
                groupIndex={colunaItem.groupIndex}
                defaultSortOrder={colunaItem.sortOrder}
                defaultSortIndex={colunaItem.sortIndex}
                //showInColumnChooser={colunaItem.formVisibleForCustomization === 1}
                dataField={colunaItem.fieldName}
                allowEditing={colunaItem.readOnly != 1}
                caption={colunaItem.fieldCaption}
                dataType={colunaItem.fieldType}
                customizeText={(cellInfo) => {
                  if (cellInfo.value?.[0] === "<") {
                    return cellInfo.value.replace(/(<([^>]+)>)/gi, "");
                  } else {
                    return cellInfo.value;
                  }
                }}
                cellRender={(cellData) => {
                  return (
                    <UpfHtmlEditor
                      referencia={refDataGrid?.current?.instance}
                      setFormDataJson={props.setFormDataJson}
                      setDataEntity={props.setDataEntity}
                      dataEntity={
                        cellData.data?.[colunaItem.fieldName]
                          ? cellData.data?.[colunaItem.fieldName]
                          : cellData.data
                      }
                      entityStructure={colunaItem}
                      colSpan={colunaItem.colSpan}
                      caption={colunaItem.fieldCaption}
                      dataField={colunaItem.fieldName}
                      disabled={!modeEditDataGrid.edit}
                      hint={colunaItem.hint}
                      setTituloQueryFormPopup={props.setTituloQueryFormPopup}
                      showEditBar={false}
                      cellData={cellData}
                    />
                  );
                }}
              />
            );
          } else if (colunaItem.editorType === "upfAudio") {
            return (
              <Column
                key={colunaIndice}
                fixed={colunaItem.fixed}
                visible={colunaItem.formVisible === 1}
                groupIndex={colunaItem.groupIndex}
                defaultSortOrder={colunaItem.sortOrder}
                defaultSortIndex={colunaItem.sortIndex}
                //showInColumnChooser={colunaItem.formVisibleForCustomization === 1}
                dataField={colunaItem.fieldName}
                allowEditing={colunaItem.readOnly != 1}
                caption={colunaItem.fieldCaption}
                dataType={colunaItem.fieldType}
                cellRender={(cellData) => {
                  return (
                    <UpfAudio
                      referencia={refDataGrid?.current?.instance}
                      setFormDataJson={props.setFormDataJson}
                      setDataEntity={props.setDataEntity}
                      dataEntity={cellData.data?.[colunaItem.fieldName]}
                      entityStructure={colunaItem}
                      colSpan={colunaItem.colSpan}
                      caption={colunaItem.fieldCaption}
                      dataField={colunaItem.fieldName}
                      disabled={!modeEditDataGrid.edit}
                      hint={colunaItem.hint}
                      setTituloQueryFormPopup={props.setTituloQueryFormPopup}
                      dadosDaEntidadeDetalheState={dataSourceAtualState}
                      setDadosDaEntidadeDetalheState={setDataSourceAtualState}
                      // showEditBar={false}
                      cellData={cellData}
                    />
                  );
                }}
              />
            );
          } else if (colunaItem.editorType === "upfFileSelect") {
            return (
              <Column
                key={colunaIndice}
                fixed={colunaItem.fixed}
                visible={colunaItem.formVisible === 1}
                groupIndex={colunaItem.groupIndex}
                defaultSortOrder={colunaItem.sortOrder}
                defaultSortIndex={colunaItem.sortIndex}
                //showInColumnChooser={colunaItem.formVisibleForCustomization === 1}
                dataField={colunaItem.fieldName}
                // allowEditing={colunaItem.readOnly != 1}
                allowEditing={false}
                caption={colunaItem.fieldCaption}
                dataType={colunaItem.fieldType}
                hint={"Selecionar arquivo"}
                disabled={true}
                cellRender={(cellData) => {
                  return (
                    <UpfFileSelect
                      referencia={refDataGrid?.current?.instance}
                      cellData={cellData}
                      setDadosDaEntidadeDetalheState={setDataSourceAtualState}
                      dadosDaEntidadeDetalheState={dataSourceAtualState}
                      dataEntity={
                        cellData.data?.[colunaItem.fieldName]
                          ? cellData.data?.[colunaItem.fieldName]
                          : cellData.data
                      }
                      entityStructure={colunaItem}
                      dataField={colunaItem.fieldName}
                      disabled={!modeEditDataGrid.edit}
                      entityName={props.entityNameGrid}
                    />
                  );
                }}
              />
            );
          } else if (colunaItem.editorType === "upfPassword") {
            return (
              <Column
                hint={colunaItem.hint}
                helpText={colunaItem.hintDocked ? colunaItem.hint : null}
                // colSpan={colSpanFieldsFunction(colunaItem.colSpan, props.colCount)}
                caption={colunaItem.fieldCaption}
                dataField={colunaItem.fieldName}
                dataSource={props.dataEntity}
                key={colunaIndice}
                fixed={colunaItem.fixed}
                visible={colunaItem.formVisible === 1}
                groupIndex={colunaItem.groupIndex}
                defaultSortOrder={colunaItem.sortOrder}
                defaultSortIndex={colunaItem.sortIndex}
                //showInColumnChooser={colunaItem.formVisibleForCustomization === 1}
                allowEditing={colunaItem.readOnly != 1}
                dataType={colunaItem.fieldType}
                editorOptions={{ mode: "password" }}
                allowFiltering={false}
                cellRender={(cellData) => {
                  return (
                    <UpfPasswordComponent
                      defaultValue={cellData.value}
                      // colSpan={colSpanFieldsFunction(colunaItem.colSpan, props.colCount)}
                      modeEditOn={props.modeEditOn}
                      entityStructure={colunaItem}
                      setModeEditForm={props.setModeEditForm}
                      setFormDataJson={props.setFormDataJson}
                      setDataEntity={props.setDataEntity}
                      // dataEntity={props.dataEntity}
                      modeEditForm={props.modeEditForm}
                      isGrid={true}
                      referencia={refDataGrid?.current?.instance}
                      dataEntity={
                        cellData.data?.[colunaItem.fieldName]
                          ? cellData.data?.[colunaItem.fieldName]
                          : cellData.data
                      }
                      colSpan={colunaItem.colSpan}
                      caption={colunaItem.fieldCaption}
                      dataField={colunaItem.fieldName}
                      disabled={!modeEditDataGrid.edit}
                      hint={colunaItem.hint}
                      setTituloQueryFormPopup={props.setTituloQueryFormPopup}
                      showEditBar={false}
                      cellData={cellData}
                      editando={modeEditDataGrid.edit}
                      allowEditing={
                        colunaItem.readOnly != 1 &&
                        fieldPermissions?._edit === 1
                      }
                    />
                  );
                }}
              ></Column>
            );
          } else if (colunaItem.fieldType === "money") {
            return (
              <Column
                visible={colunaItem.formVisible === 1}
                //showInColumnChooser={colunaItem.visibleForCustomization === 1}
                dataField={colunaItem.fieldName}
                groupIndex={
                  !colunaItem?.groupIndex ? -1 : colunaItem?.groupIndex
                }
                sortOrder={colunaItem.sortOrder}
                allowEditing={colunaItem.readOnly != 1}
                caption={colunaItem.fieldCaption}
                // dataType={colunaItem.fieldType}
                format={{
                  style: "currency",
                  currency: "BRL",
                  precision: 2,
                }}
              />
            );
          } else {
            return (
              <Column
                key={colunaIndice}
                fixed={colunaItem.fixed}
                visible={colunaItem.gridVisible === 1}
                groupIndex={
                  !colunaItem?.groupIndex ? -1 : colunaItem?.groupIndex
                }
                defaultSortOrder={colunaItem.sortOrder}
                defaultSortIndex={colunaItem.sortIndex}
                showInColumnChooser={
                  colunaItem.gridVisibleForCustomization === 1
                }
                dataField={colunaItem.fieldName}
                allowEditing={colunaItem.readOnly != 1}
                caption={colunaItem.fieldCaption}
                // format={formatFunction(colunaItem.fieldMask,  "column", colunaItem.fieldName, dadosDaEntidadeDetalheState.records, modeEditDataGrid?.edit)}
                // dataType={"datetime"}
                // editorOptions={editorOptionsColumns}

                // format={colunaItem.fieldMask}
                //width={colunaItem.FieldSize}
              ></Column>
            );
          }
        })}

        <Summary calculateCustomSummary={calculateCustomSummary}>
          <TotalItem
            column={
              refDataGrid?.current?.instance.getVisibleColumns()[1]?.dataField
            }
            summaryType="count"
            customizeText={(data) => `Qtd: ${data.value}`}
          />
          <TotalItem
            name={`{"tipo": "count", "columnName": "${
              refDataGrid?.current?.instance.getVisibleColumns()[1]?.dataField
            }"}`}
            summaryType="custom"
            displayFormat="Sel.: {0}"
            showInColumn={
              refDataGrid?.current?.instance.getVisibleColumns()[1]?.dataField
            }
          />

          {props.colunasArray?.length > 0 &&
            props.colunasArray?.map((item, indice) => {
              if (item.fieldType === "money") {
                return (
                  <TotalItem
                    column={item.fieldName}
                    summaryType="sum"
                    fieldType={item.fieldType}
                    showInGroupFooter={false}
                    alignByColumn={true}
                    rowRenderingMode="standard"
                    format={{
                      style: "currency",
                      currency: "BRL",
                      precision: 2,
                    }}
                    customizeText={(data) =>
                      `Total: ${convertNumberToCurrency.format(data.value)}`
                    }
                  />
                );
              }
              // else {
              //     return (
              //         <TotalItem
              //             column={item.fieldName}
              //             summaryType={item.summarytype}
              //             fieldType={item.fieldType}
              //             showInGroupFooter={false}
              //             alignByColumn={true}
              //             rowRenderingMode="standard"
              //         />
              //     )
              // }
            })}

          {props.colunasArray?.length > 0 &&
            props.colunasArray?.map((item, indice) => {
              if (item.fieldType === "money") {
                return (
                  <TotalItem
                    name={`{"tipo": "value", "columnName": "${item.fieldName}"}`}
                    summaryType="custom"
                    valueFormat={{
                      style: "currency",
                      currency: "BRL",
                      precision: 2,
                    }}
                    displayFormat="Sel.: {0}"
                    showInColumn={item.fieldName}
                  />
                );
              }
            })}
        </Summary>
      </DataGrid>
    </>
  );
};

export default UpfDataGridField;
